import React, { useEffect, useState } from 'react';
import { createRoot } from 'react-dom/client';
import { ThemeProvider } from '@mui/material/styles';
import { ToastNotification, theme as bsTheme } from 'bs-unified-ui';

const Wrapper = (props) => {
  const [open, setOpen] = useState(false);

  const close = () => {
    setOpen(false);
  };

  useEffect(() => {
    setOpen(true);
  }, [props]);

  return (
    <ThemeProvider theme={bsTheme}>
      <ToastNotification
        open={open}
        onClose={close}
        autoHideDuration={3000}
        {...props}
      />
    </ThemeProvider>
  );
};

export const showToast = (message, props = {}) => {
  const root = createRoot(document.getElementById('toast'));
  root.render(<Wrapper message={message} {...props} />);
};
